import { CircleEllipsis, Share, SquarePlus } from "lucide-react";
import type { ReactNode } from "react";

function Step({ icon, children }: { icon: ReactNode; children: ReactNode }) {
  return (
    <div className="flex items-center gap-3">
      <span
        className="flex h-10 w-10 shrink-0 items-center justify-center text-foreground [&_svg]:size-8 [&_svg]:stroke-[2.25]"
        aria-hidden
      >
        {icon}
      </span>
      <p className="text-base font-semibold leading-snug text-foreground">{children}</p>
    </div>
  );
}

export function IOSInstallInstructions() {
  return (
    <div className="mt-5 space-y-4">
      <Step icon={<Share />}>Press Share in Navigation bar</Step>
      <Step icon={<CircleEllipsis />}>Press "More" if no Share icon</Step>
      <Step icon={null}>Scroll down to "Add to Home Screen"</Step>
      <Step icon={<SquarePlus />}>Tap "Add to Home Screen"</Step>
    </div>
  );
}
